import { Grid } from '@design-system';
import { shopifyGraphqlIdToAdminId } from '@utils/shopifyIds';
import React from 'react';

import { GeneratedGetDrawByProductIDsQuery } from '../../../types/generated';
import {
  AssetStoryblok,
  PlannedReleaseStoryblok,
} from '../../../types/generated-storyblok';
import PageSection from '../../Layout/PageSection';
import ProductTile from '../../ProductTile';
import { ProductPlaceholder } from '../../ProductTile/ProductPlaceholder';

interface Props {
  upcoming?: PlannedReleaseStoryblok[];
  products?: MultiCurrencyProduct[];
  draws: GeneratedGetDrawByProductIDsQuery['getDrawByProductIDs'];

  // Planned release
  artist?: string;
  image?: AssetStoryblok;
  isSubscribed: boolean;
  isLoading: boolean;
  onSubscribe: () => Promise<void>;

  analytics: Analytics;
}

export const ArtistProductsTab: React.FC<Props> = ({
  analytics,
  artist,
  draws,
  image,
  isLoading,
  isSubscribed,
  onSubscribe,
  products,
  upcoming,
}) => {
  return (
    <div className="flex flex-col gap-9 md:gap-12">
      <PageSection>
        <div className="mx-auto w-full max-w-3xl lg:max-w-5xl">
          <Grid className="gap-y-6" columns={2}>
            {upcoming?.map((item) => (
              <div key={item._uid}>
                <ProductPlaceholder
                  artist={artist}
                  image={image}
                  isLoading={isLoading}
                  isSubscribed={isSubscribed}
                  onSubscribe={onSubscribe}
                  title={item.title}
                />
              </div>
            ))}

            {products?.map((item, i) => {
              const draw = draws?.find((d) => {
                return d.productId === shopifyGraphqlIdToAdminId(item.id);
              });

              return (
                <div key={item.id}>
                  <ProductTile
                    analytics={{
                      ...analytics,
                      position: i,
                    }}
                    draw={draw}
                    product={item}
                  />
                </div>
              );
            })}
          </Grid>
        </div>
      </PageSection>
    </div>
  );
};
